import {
  inject,
  ModuleWithProviders,
  NgModule,
  ɵstringify as stringify,
} from '@angular/core';
import { AngularApplicationInsightsConfig } from './lib/configs/config';
import { ApplicationInsightsService } from './lib/services/application-insights.service';

@NgModule({})
export class ApplicationInsightsModule {
  constructor() {
    const applicationInsightsService = inject(ApplicationInsightsService);

    const parentModule = inject(ApplicationInsightsModule, {
      optional: true,
      skipSelf: true,
    });

    if (parentModule) {
      throw new Error(
        `${stringify(ApplicationInsightsModule)} is already loaded. Import it in the AppModule only.`,
      );
    }

    applicationInsightsService.init();
  }

  /**
   * Creates and configures the AppInsights module for the entire application.
   */
  static forRoot(
    config: AngularApplicationInsightsConfig,
  ): ModuleWithProviders<ApplicationInsightsModule> {
    return {
      ngModule: ApplicationInsightsModule,
      providers: [
        { provide: AngularApplicationInsightsConfig, useValue: config },
      ],
    };
  }
}
